module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "nav-box",
    staticClass: "nav"
  }, [_c('ul', {
    staticClass: "nav-list",
    class: {
      en: _vm.language == 'en' ? true : false
    },
    style: ({
      'background-color': _vm.color,
      width: '100%'
    })
  }, _vm._l((_vm.navs), function(item, index) {
    return (item.navType != 6) ? _c('li', {
      key: index,
      staticClass: "nav-item",
      class: [item.active === true ? 'active' : ''],
      style: ({
        width: Math.floor(1008 / (_vm.navs.length)) + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.toPosition(("id_" + (item.navId)), index)
        }
      }
    }, [(item.navUrl) ? _c('a', {
      attrs: {
        "target": item.linkTarget,
        "href": item.navUrl
      }
    }, [_vm._v(_vm._s(item.navName))]) : _vm._e(), _vm._v(" "), (!item.navUrl) ? _c('span', [_vm._v("\n          " + _vm._s(item.navName) + "\n        ")]) : _vm._e(), _vm._v(" "), (item.active) ? _c('b', {
      staticClass: "nav-tip"
    }) : _vm._e(), _vm._v(" "), (index !== _vm.navs.length - 1) ? _c('b', {
      staticClass: "nav-tip2"
    }) : _vm._e()]) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c6c23b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/iNav/iNav.vue
// module id = 791
// module chunks = 10